import { lazy } from 'src/utils/lazy'
import {
  GroupIcon,
  OptionsIcon,
  PersonIcon,
  PrayerIcon,
  TopicIcon,
} from '../Icons'
import type {
  InternalRouteConfig,
  MenuRouteConfig,
  ProtectedPageId,
  PublicPageId,
} from './types'


const CreateAccountPage = lazy(() => import('./CreateAccount'))
const ItemPage = lazy(() => import('./ItemPage'))
const LoginPage = lazy(() => import('./Login'))
const PrayerPage = lazy(() => import('./Prayer'))
const SettingsPage = lazy(() => import('./Settings'))
const WelcomePage = lazy(() => import('./Welcome'))

// Internal routes (not in the main menu)
export const PUBLIC_ROUTES = {
  welcome: {
    path: '/welcome',
    requiresAuth: false,
    page: <WelcomePage />,
  },
  login: {
    path: '/login',
    requiresAuth: false,
    page: <LoginPage />,
  },
  signup: {
    path: '/signup',
    requiresAuth: false,
    page: <CreateAccountPage />,
  },
} as const satisfies Record<PublicPageId, InternalRouteConfig>

// Main menu routes
export const PROTECTED_ROUTES = {
  prayer: {
    name: 'Prayer',
    icon: PrayerIcon,
    path: '/',
    requiresAuth: true,
    noPlaceholderDrawer: true,
    page: <PrayerPage />,
  },
  people: {
    name: 'People',
    icon: PersonIcon,
    path: '/people',
    requiresAuth: true,
    dividerBefore: true,
    page: <ItemPage itemType="person" />,
  },
  groups: {
    name: 'Groups',
    icon: GroupIcon,
    path: '/groups',
    requiresAuth: true,
    page: <ItemPage itemType="group" />,
  },
  topics: {
    name: 'Topics',
    icon: TopicIcon,
    path: '/topics',
    requiresAuth: true,
    page: <ItemPage itemType="topic" />,
  },
  settings: {
    name: 'Settings',
    icon: OptionsIcon,
    path: '/settings',
    requiresAuth: true,
    dividerBefore: true,
    noPlaceholderDrawer: true,
    page: <SettingsPage />,
  },
} as const satisfies Record<ProtectedPageId, MenuRouteConfig>

export const ROUTES = {
  ...PUBLIC_ROUTES,
  ...PROTECTED_ROUTES,
}
